// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95a7ceb0","455":"f29a6c3a","977":"57ebfa11"}[chunkId] + ".chunk.js";
};